import { TextBookWrap } from './TextBookWrap';
export default TextBookWrap;
